const currentHost = window.location.hostname;

document.querySelectorAll('a[href]').forEach(link => {
	try {
		const url = new URL(link.href, window.location.origin);

		if (url.hostname !== currentHost) {
			if (link.target !== '_blank') {
				link.setAttribute('target', '_blank');
			}

			const ariaLabel = link.getAttribute('aria-label') || '';
			const ariaLabelText = ariaLabel ? ariaLabel + ' (' + bds_theme.strings.opens_new_window + ')' : bds_theme.strings.opens_new_window;

			link.setAttribute('aria-label', ariaLabelText);
		}
	} catch (e) {
		// Ignore invalid URLs.
	}
});
